// SPDX-License-Identifier: AGPL-3.0-or-later

import CompanionSessionStore from '@app/features/companion/state/CompanionSessionStore';
import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';

interface CompanionTranscriptPayload {
	session_id: string;
	segment_id: string;
	speaker_id: string;
	role?: 'self' | 'customer' | 'ai';
	text: string;
	timestamp_ms: number;
	// false = ASR 中间结果(流式上屏, 定稿后同 segment_id 原位替换)。
	final: boolean;
}

export function handleCompanionTranscript(data: CompanionTranscriptPayload, _context: GatewayHandlerContext): void {
	CompanionSessionStore.handleTranscript(data);
}
